import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';
import ServiceIndex from '@/views/auth/service/index.vue';
import ServiceEdit from '@/views/auth/service/_id.vue';

export default [
    {
        path: '/service',
        name: 'service',
        component: ServiceIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.MANAGER],
            title: () => getI18nInstance().t('service_pages'),
        },
    },
    {
        path: '/service/:id',
        component: ServiceEdit,
        name: 'service-edit',
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.MANAGER],
            title: () => getI18nInstance().t('service_pages'),
        },
    },
];
